import { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate, Outlet } from 'react-router-dom';
import {
  LayoutDashboard,
  Gamepad2,
  Trophy,
  Megaphone,
  LogOut,
  Menu,
  X,
  ChevronRight,
  Shield,
  Bell,
  Settings,
} from 'lucide-react';
import './AdminLayout.css';

const NAV_ITEMS = [
  { to: 'home',        label: 'Dashboard',    Icon: LayoutDashboard },
  { to: 'games',       label: 'Games',         Icon: Gamepad2 },
  { to: 'gamesresult', label: 'Game Results',  Icon: Trophy },
  { to: 'admanager',   label: 'Ad Manager',    Icon: Megaphone },
];

export default function AdminLayout({ update }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  // Close sidebar on route change (mobile)
  useEffect(() => { setSidebarOpen(false); }, [location.pathname]);

  const handleLogout = () => {
    update();
    localStorage.removeItem('token');
    localStorage.removeItem('loggedIn');
    navigate('/');
  };

  // Active page title for header
  const activeItem = NAV_ITEMS.find(n => location.pathname.includes(n.to));
  const pageTitle = activeItem?.label || 'Admin Panel';

  return (
    <div className="admin-shell">

      {/* ─── Mobile Overlay ─────────────────────────────── */}
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* ─── Sidebar ────────────────────────────────────── */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'mobile-open' : ''}`}>
        {/* Brand */}
        <div className="sidebar-logo">
          <div className="sidebar-logo-icon">
            <Shield size={18} />
          </div>
          <div>
            <div className="sidebar-logo-text">Satta Bazar</div>
            <div className="sidebar-logo-sub">Admin Dashboard</div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="sidebar-nav">
          <div className="sidebar-label">Main Menu</div>

          {NAV_ITEMS.map(({ to, label, Icon }) => (
            <NavLink
              key={to}
              to={to}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'active' : ''}`
              }
            >
              <Icon className="sidebar-link-icon" size={18} />
              {label}
              {location.pathname.includes(to) && (
                <ChevronRight size={14} style={{ marginLeft: 'auto', opacity: 0.5 }} />
              )}
            </NavLink>
          ))}
        </nav>

        {/* User + Logout */}
        <div className="sidebar-bottom">
          <div className="sidebar-user" style={{ marginBottom: '8px' }}>
            <div className="sidebar-user-avatar">A</div>
            <div>
              <div className="sidebar-user-name">Admin</div>
              <div className="sidebar-user-role">Super Admin</div>
            </div>
          </div>
          <button className="sidebar-link" onClick={handleLogout} style={{ color: '#f87171' }}>
            <LogOut size={18} className="sidebar-link-icon" />
            Logout
          </button>
        </div>
      </aside>

      {/* ─── Main Content ───────────────────────────────── */}
      <div className="admin-main">
        {/* Header */}
        <header className="admin-header">
          <div className="admin-header-left">
            <button
              className="hamburger-btn"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-label="Toggle sidebar"
            >
              {sidebarOpen ? <X size={22} /> : <Menu size={22} />}
            </button>
            <div>
              <div className="admin-page-title">{pageTitle}</div>
              <div className="admin-breadcrumb">Satta Bazar › {pageTitle}</div>
            </div>
          </div>
          <div className="admin-header-right">
            <button className="btn btn-ghost btn-sm" style={{ padding: '6px' }}>
              <Bell size={18} />
            </button>
            <div className="header-avatar">A</div>
          </div>
        </header>

        {/* Page */}
        <div className="admin-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
